var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountInfoNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Account_Info_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account_Info_Normal",
    "data-name": "Account Info_Normal",
    clipPath: "url(#clip-Account_Info_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account_Info",
    "data-name": "Account Info",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2080",
    "data-name": "Group 2080",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2079",
    "data-name": "Group 2079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2077",
    "data-name": "Group 2077",
    transform: "translate(0 15.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4577",
    "data-name": "Path 4577",
    d: "M21.685,29.512h6.4a1.7,1.7,0,0,0,1.709-1.7V25.641c0-.1-5.379-3.274-5.413-3.375-.694-3.644,1.486-5.626-2.372-5.626H15.3a7.879,7.879,0,0,0-7.751,6.394,1.863,1.863,0,0,0-.034.321v4.454a1.7,1.7,0,0,0,1.709,1.7h6.837",
    transform: "translate(-6.879 -15.982)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4578",
    "data-name": "Path 4578",
    d: "M28.341,30.472h-6.4a.675.675,0,1,1,0-1.35h6.4a1.035,1.035,0,0,0,1.032-1.029V25.784s-4.3-2.28-4.3-2.331c-1.625-3.607.675-5.854-2.794-5.854h-6.7a7.211,7.211,0,0,0-7.09,5.854v4.639a1.035,1.035,0,0,0,1.032,1.029h6.836a.675.675,0,1,1,0,1.35H9.526A2.38,2.38,0,0,1,7.14,28.093V23.639a1.847,1.847,0,0,1,.034-.439A8.556,8.556,0,0,1,15.6,16.25h6.7c4.112,0-.036,3.909,4.152,8.159.034.135,4.309,1.223,4.309,1.375v2.309a2.38,2.38,0,0,1-2.386,2.379Z",
    transform: "translate(-7.14 -16.25)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2078",
    "data-name": "Group 2078",
    transform: "translate(5.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4579",
    "data-name": "Path 4579",
    d: "M22.575,13.753A6.023,6.023,0,1,1,16.553,7.73,6.026,6.026,0,0,1,22.575,13.753Z",
    transform: "translate(-9.855 -7.055)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4580",
    "data-name": "Path 4580",
    d: "M16.828,20.725a6.7,6.7,0,1,1,6.7-6.7A6.7,6.7,0,0,1,16.828,20.725Zm0-12.045a5.348,5.348,0,1,0,5.348,5.348A5.35,5.35,0,0,0,16.828,8.68Z",
    transform: "translate(-10.13 -7.33)",
    fill: "#6f8b8f"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4581",
    "data-name": "Path 4581",
    d: "M14.973,25.23h-.658a.675.675,0,0,1,0-1.35h.658a.675.675,0,0,1,0,1.35Z",
    transform: "translate(-2.639 4.77)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2083",
    "data-name": "Group 2083",
    transform: "translate(16.095 11.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2081",
    "data-name": "Group 2081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4582",
    "data-name": "Path 4582",
    d: "M23.592,27.812a6.958,6.958,0,0,1-6.36-4.15,6.949,6.949,0,0,1,8.874-9.279,6.949,6.949,0,0,1,.287,12.838A7.072,7.072,0,0,1,23.592,27.812Zm0-12.552A5.588,5.588,0,1,0,28.7,18.584h0a5.626,5.626,0,0,0-5.112-3.34Z",
    transform: "translate(-16.639 -13.909)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4829",
    "data-name": "Path 4829",
    d: "M23.592,27.812a6.958,6.958,0,0,1-6.36-4.15,6.949,6.949,0,0,1,8.874-9.279,6.949,6.949,0,0,1,.287,12.838A7.072,7.072,0,0,1,23.592,27.812Zm0-12.552A5.588,5.588,0,1,0,28.7,18.584h0a5.626,5.626,0,0,0-5.112-3.34Z",
    transform: "translate(-16.639 -13.909)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2082",
    "data-name": "Group 2082",
    transform: "translate(5.974 3.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4583",
    "data-name": "Path 4583",
    d: "M21.873,17.84v3.577h-1.6V17.84Z",
    transform: "translate(-20.118 -14.888)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 0.978,
    cy: 0.978,
    r: 0.978,
    fill: "#6f8b8f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountInfoNormal);
export default __webpack_public_path__ + "static/media/Account_Info_Normal.07db3512b46f701a78afca528581134e.svg";
export { ForwardRef as ReactComponent };